function HomePage({ children }) {
  return <div className="container">{children}</div>;
}

export default HomePage;
